
import ScheduleWidget from "@/components/dashboard/ScheduleWidget";
import EarningsWidget from "@/components/dashboard/EarningsWidget";
import RatingWidget from "@/components/dashboard/RatingWidget";

const DashboardWidgets = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
      <ScheduleWidget />
      <EarningsWidget />
      <RatingWidget />
    </div>
  );
};

export default DashboardWidgets;
